import { Plugin } from '../models/Plugin'
import { createPinia } from 'pinia'

export const install: Plugin['fn'] = (app) => {
  app.use(createPinia())
}
